import { endpoints } from "config";
import { SupplierFeedbackRow } from "./SupplierFeedbackList.types";
import { CellOptions } from "components/newFlexTable/Cell";

export const SUPPLIER_FEEDBACK_LIST_COLUMNS = {
  Id: "supplierFeedbackTypes__Id" as const,
  Name: "supplierFeedbackTypes__FeedbackName" as const,
  Active: "SupplierFeedbackTypes__bActive" as const,
};

export const SUPPLIER_FEEDBACK_LIST_ENDPOINTS = {
  delete: endpoints.supplierFeedback.delete,
  list: endpoints.supplierFeedback.list,
};

export const rowCellOptions: Record<keyof SupplierFeedbackRow, CellOptions> = {
  supplierFeedbackTypes__Id: { width: "Small" },
  supplierFeedbackTypes__FeedbackName: { width: "Large" },
  supplierFeedbackTypes__bActive: { width: "Small" },
  supplierFeedbackTypes__AddDate: { width: "Medium2" },
  supplierFeedbackTypes__AddedBy: { width: "Medium2" },
  supplierFeedbackTypes__EditDate: { width: "Medium2" },
  supplierFeedbackTypes__LastEditedBy: { width: "SemiLarge2" },
};
